import * as amplitude from '@amplitude/analytics-browser';

export function initAmplitude() {
  // Disabled due to quota exceeded. Session replay was already removed in
  // CX-4920 (#2535); this gate now disables the remaining event tracking too.
  // All trackXxx methods and their call sites are kept as dead code — see
  // AnalyticsClient.track(). Set REACT_APP_AMPLITUDE_ENABLED=true (in the
  // relevant .env.<environment> file) to re-enable once quota is restored.
  if (process.env.REACT_APP_AMPLITUDE_ENABLED !== 'true') return;

  const apiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;
  if (!apiKey) return;

  amplitude.init(apiKey, { defaultTracking: false });
}
